import React, { useState } from "react"
import { navigate } from "gatsby-link"

import Layout from "../components/Layout"
import Head from "../components/Head"

import contactStyles from "./contact.module.scss"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Contact = () => {
  // this will get all the inputs as name: inputvalue
  const [input, setInput] = useState({})

  const handleChange = e =>
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    })

  const handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...input,
      }),
    })
      .then(() => navigate(form.getAttribute("action")))
      .catch(error => alert(error))

    e.target.reset()
  }

  return (
    <Layout>
      <Head title="Contact me!" />
      <h1 className="title">Contact Me</h1>
      <div className={contactStyles.container}>
        <div
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease-out-back"
        >
          <div className={contactStyles.thumbsUp}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="237.272"
              height="241"
              viewBox="0 0 237.272 241"
            >
              <g id="good" transform="translate(-0.501 -0.001)">
                <path
                  id="Path_18"
                  data-name="Path 18"
                  d="M218.988,162.044A105.264,105.264,0,1,1,113.722,56.777,105.266,105.266,0,0,1,218.988,162.044Zm0,0"
                  transform="translate(-4.213 -30.052)"
                  fill="#1c528a"
                />
                <path
                  id="Path_19"
                  data-name="Path 19"
                  d="M213.689,56.777a106.17,106.17,0,0,0-16.361,1.267,105.277,105.277,0,0,1,.009,207.992A105.268,105.268,0,1,0,213.689,56.777Zm0,0"
                  transform="translate(-104.18 -30.052)"
                  fill="#1c528a"
                />
                <path
                  id="Path_20"
                  data-name="Path 20"
                  d="M323.605,128.972l-60.11,39.8a20.469,20.469,0,0,1-14.54,3.152,20.537,20.537,0,0,0-14.575,3.144l-8.044,5.33L181.286,114,192.338,66.25a49.818,49.818,0,0,0-7-38.754,11.915,11.915,0,0,1,18.227-15.134l7.16,6.936A76.548,76.548,0,0,1,229.2,47.613l3.883,10.453,39.982-26.416a13.634,13.634,0,0,1,19.1,4.161,13.814,13.814,0,0,1-4.282,18.729.15.15,0,0,0-.055.189.152.152,0,0,0,.195.075,13.507,13.507,0,0,1,4.873-.9,13.627,13.627,0,0,1,13.386,16.278,13.935,13.935,0,0,1-5.716,8.634.293.293,0,0,0-.075.4.01.01,0,0,0,.011.009.287.287,0,0,0,.384.075,13.976,13.976,0,0,1,3.308-.39,14.371,14.371,0,0,1,7.689,2.228,13.4,13.4,0,0,1,3.977,3.9,13.63,13.63,0,0,1-3.843,18.892c-.154.1-.309.21-.463.309a.213.213,0,0,0-.07.267.129.129,0,0,0,.05.05.219.219,0,0,0,.27-.011,13.35,13.35,0,0,1,11.567,1.489,13.842,13.842,0,0,1,4.071,4.038,13.638,13.638,0,0,1-3.835,18.9Zm0,0"
                  transform="translate(-95.689 -4.763)"
                  fill="#ffd4c4"
                />
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M136.547,300.823,111.19,317.616,74.58,341.861a105.377,105.377,0,0,1-64.017-82.82l42.486-28.136,25.863-17.127a6.468,6.468,0,0,1,8.967,1.828l50.5,76.243a6.476,6.476,0,0,1-1.828,8.975Zm0,0"
                  transform="translate(-5.326 -112.582)"
                  fill="#fff"
                />
                <path
                  id="Path_22"
                  data-name="Path 22"
                  d="M184.322,300.823l-25.357,16.793-58.141-86.711,25.863-17.127a6.468,6.468,0,0,1,8.967,1.828l50.5,76.243a6.476,6.476,0,0,1-1.828,8.975Zm0,0"
                  transform="translate(-53.101 -112.582)"
                  fill="#fbfafe"
                />
                <g
                  id="Group_17"
                  data-name="Group 17"
                  transform="translate(176.371 49.135)"
                >
                  <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M402.4,106.575l-20,10.7a6.48,6.48,0,0,1-8.265-1.859l15.769-10.2a.151.151,0,0,0,.195.075,13.507,13.507,0,0,1,4.873-.9,13.73,13.73,0,0,1,7.43,2.188Zm0,0"
                    transform="translate(-374.133 -104.387)"
                    fill="#fac5aa"
                  />
                  <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M427.439,159.756l-19.565,10.462a6.474,6.474,0,0,1-8.265-1.853l15.769-10.2.68-.32a.286.286,0,0,0,.384.075,14,14,0,0,1,3.308-.39,14.346,14.346,0,0,1,7.689,2.228Zm0,0"
                    transform="translate(-387.617 -132.514)"
                    fill="#fac5aa"
                  />
                  <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M454.47,212.7l-17.234,9.219a6.482,6.482,0,0,1-8.263-1.859l13.66-8.839a.219.219,0,0,0,.27-.011A13.35,13.35,0,0,1,454.47,212.7Zm0,0"
                    transform="translate(-403.16 -160.556)"
                    fill="#fac5aa"
                  />
                </g>
                <path
                  id="Path_26"
                  data-name="Path 26"
                  d="M234.877,103.244a17.262,17.262,0,0,0-10.69-7.358A17.361,17.361,0,0,0,212.609,70.86a17.4,17.4,0,0,0-.9-17.684,17.248,17.248,0,0,0-10.69-7.358,17.379,17.379,0,0,0-24.982-22.572L158.736,34.7a108.12,108.12,0,0,0-29.213-9.887A80.33,80.33,0,0,0,118.375,11.33l-7.158-6.937a15.662,15.662,0,0,0-23.96,19.893q.281.427.553.859A109.015,109.015,0,1,0,212.069,169.018a3.747,3.747,0,1,0-7.048-2.545A101.652,101.652,0,0,1,77.455,228.341l30.489-20.191.006,0s0,0,0,0l25.339-16.78h0a10.221,10.221,0,0,0,2.879-14.163l-.335-.507,4.922-3.26a16.692,16.692,0,0,1,11.894-2.57,24.161,24.161,0,0,0,17.219-3.723L210.7,140.1a101.734,101.734,0,0,1-1.381,10.525,3.746,3.746,0,0,0,3,4.369,3.656,3.656,0,0,0,.688.064A3.748,3.748,0,0,0,216.688,152a109.593,109.593,0,0,0,1.791-17.043l11.5-7.62a17.382,17.382,0,0,0,4.895-24.089ZM151.46,39.521,140.011,47.1l-2.254-6.073a80.19,80.19,0,0,0-3.216-7.448,100.589,100.589,0,0,1,16.92,5.939ZM32.8,65.5A101.526,101.526,0,0,1,91.4,32.089a46.294,46.294,0,0,1,2.335,28.038L84.594,99.6a10.2,10.2,0,0,0-13.079-1.524L45.636,115.21l0,0a0,0,0,0,0,0,0L8.305,139.932c-.2-2.633-.311-5.286-.311-7.938A101.487,101.487,0,0,1,32.8,65.5Zm97.525,117.883a2.714,2.714,0,0,1-1.169,1.732h0L106.9,199.852l-41.306-61.6a3.747,3.747,0,0,0-6.224,4.174l41.28,61.567-31.771,21.04a101.83,101.83,0,0,1-59.593-76.9l37.369-24.666,4.3,6.417a3.748,3.748,0,1,0,6.226-4.174l-4.271-6.371,22.744-15.013a2.727,2.727,0,0,1,3.777.77l50.494,76.246a2.7,2.7,0,0,1,.4,2.045Zm99.752-68.574a9.82,9.82,0,0,1-4.231,6.275l-13.152,8.71a.079.079,0,0,1-.013.007L165.735,160.89a16.683,16.683,0,0,1-11.894,2.57,24.174,24.174,0,0,0-17.219,3.723l-4.922,3.26L90.344,108l10.69-46.179a53.84,53.84,0,0,0-3.942-35.343,3.672,3.672,0,0,0-.158-.333,53.007,53.007,0,0,0-3.429-6A8.168,8.168,0,0,1,106,9.773l7.158,6.939a73.216,73.216,0,0,1,17.57,26.927l3.9,10.5c.007.02.015.037.022.055l.029.074c.028.064.053.123.081.173a3.7,3.7,0,0,0,.257.463,3.745,3.745,0,0,0,5.192,1.055l39.967-26.466A9.887,9.887,0,1,1,191.094,45.98l-3.47,2.3,0,0-7.739,5.126a.281.281,0,0,1-.029.02c-.044.031-.086.061-.121.09a3.745,3.745,0,0,0,4.29,6.138l7.745-5.13a9.887,9.887,0,0,1,10.913,16.491l-11.212,7.426A3.747,3.747,0,1,0,195.6,84.69l1.736-1.149,6.005-3.977a9.887,9.887,0,0,1,10.918,16.487l-5.6,3.709c-.029.018-.059.039-.088.059l-5.523,3.657a3.747,3.747,0,1,0,4.137,6.25l1.736-1.149a0,0,0,0,1,0,0l6.005-3.975a9.884,9.884,0,0,1,15.145,10.21Zm0,0"
                  transform="translate(0 0)"
                />
              </g>
            </svg>
          </div>
          <div className="project-tags">
            <h1>Looking for a colleague?</h1>
            <p>Get in touch!</p>
          </div>
        </div>

        <div
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-easing="ease-out-back"
          className={contactStyles.contact}
        >
          <form
            name="contact"
            method="post"
            action="/thanks"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="contact" />

            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              name="name"
              // value={name}
              placeholder="Your name"
              // onChange={e => setName(e.target.value)}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              // value={email}
              placeholder="Email"
              // onChange={e => setEmail(e.target.value)}
              onChange={handleChange}
              required
            />

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              // value={message}
              placeholder="What's your message for me?"
              // onChange={e => setMessage(e.target.value)}
              onChange={handleChange}
              required
            ></textarea>

            <input type="submit" value="Send" className="button" />
          </form>
        </div>
      </div>
    </Layout>
  )
}

export default Contact
